import React, { useEffect, useState } from 'react';
import Header from './Header';
import MainHeader from './MainHeader';
import Footer from './Footer';
import Sidebar from './SideNavigation';
import SidebarOryza from './SideNavigation';
import YogaAndPoolSection from './YogaAndPoolSection';
import DiningAndLoungeSection from './DiningAndLoungeSection';
import './AboutUsPage.css';

// Custom scroll animation hook
const useScrollAnimation = (elementId, offset = 0.8) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const element = document.getElementById(elementId);
      if (!element) return;
      
      const elementTop = element.getBoundingClientRect().top;
      const windowHeight = window.innerHeight;
      
      if (elementTop < windowHeight * offset) {
        setIsVisible(true);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check on initial render

    return () => window.removeEventListener('scroll', handleScroll);
  }, [elementId, offset]);

  return isVisible;
};

const AboutUsPage = () => {
  // Mobile detection
  const [isMobile, setIsMobile] = useState(false);
  
  // Scroll animations for different sections
  const leftColVisible = useScrollAnimation('left-column');
  const rightColVisible = useScrollAnimation('right-column');
  const statsVisible = useScrollAnimation('stats-column');
  const textVisible = useScrollAnimation('text-column');

  useEffect(() => {
    const checkScreen = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkScreen();
    window.addEventListener('resize', checkScreen);
    return () => window.removeEventListener('resize', checkScreen);
  }, []);

  // Back to top button functionality
  useEffect(() => {
    const progressPath = document.querySelector('.progress-wrap path');
    if (progressPath) {
      const pathLength = progressPath.getTotalLength();
      progressPath.style.transition = 'none';
      progressPath.style.strokeDasharray = `${pathLength} ${pathLength}`;
      progressPath.style.strokeDashoffset = pathLength;
      progressPath.getBoundingClientRect();
      progressPath.style.transition = 'stroke-dashoffset 10ms linear';

      const updateProgress = () => {
        const scroll = window.pageYOffset;
        const height = document.documentElement.scrollHeight - window.innerHeight;
        const progress = pathLength - (scroll * pathLength / height);
        progressPath.style.strokeDashoffset = progress;
      };

      window.addEventListener('scroll', updateProgress);
      return () => window.removeEventListener('scroll', updateProgress);
    }
  }, []);

  const headingStyle = {
    fontFamily: "'Yellowtail', cursive",
    fontWeight: 400,
    fontSize: isMobile ? '40px' : '79px',
    lineHeight: isMobile ? '48px' : '95px',
    color: '#fff',
  };

  return (
    <div className="hotale-body-wrapper">
      <Header />
      <MainHeader />
      <Sidebar />
      <SidebarOryza />

      <div className="home page-template-default page page-id-15043 theme-hotale gdlr-core-body tourmaster-body woocommerce-no-js hotale-body hotale-body-front hotale-full hotale-with-sticky-navigation hotale-blockquote-style-3 gdlr-core-link-to-lightbox">
        {/* Page Title */}
        <div className="hotale-page-title-wrap hotale-style-custom hotale-center-align">
          <div className="hotale-header-transparent-substitute" style={{ height: '135px' }}></div>
          <div className="hotale-page-title-overlay"></div>
          <div className="hotale-page-title-container hotale-container">
            <div className="hotale-page-title-content hotale-item-pdlr">
              <h1 className="gdlr-core-title-item-title gdlr-core-skin-title class-test hotale-additional-font slidertitle" style={headingStyle}>
                About Us
              </h1>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="hotale-page-wrapper" id="hotale-page-wrapper">
          <div className="gdlr-core-page-builder-body">

            {/* First Section */}
            <div className="gdlr-core-pbf-wrapper" style={{ padding: 0 }}>
              <div className="gdlr-core-pbf-background-wrap">
                <div className="gdlr-core-pbf-background gdlr-core-parallax"></div>
              </div>
              <div className="gdlr-core-pbf-wrapper-content bbkandybg">
                <div className="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container">
                  {/* Left Column */}
                  <div id="left-column" className="gdlr-core-pbf-column gdlr-core-column-30 gdlr-core-column-first">
                    <div className="gdlr-core-pbf-column-content-margin" style={{ margin: '0px', padding: '40px 90px 0px 0px' }}>
                      <div className={`green_back_about fade-in-left ${leftColVisible ? 'is-visible' : ''}`}>
                        <div className="gdlr-core-pbf-element">
                          <div className="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr" style={{ paddingBottom: '20px' }}>
                            <div className="gdlr-core-title-item-title-wrap">
                              <h3 className="gdlr-core-title-item-title gdlr-core-skin-title class-test hotale-additional-font"
                                  style={{ fontSize: '62px', fontWeight: '400', letterSpacing: '0px', textTransform: 'none' }}>
                                Bananas & Bunks
                              </h3>
                            </div>
                          </div>
                        </div>
                        <div className="gdlr-core-pbf-element">
                          <div className="gdlr-core-divider-item gdlr-core-divider-item-normal gdlr-core-item-pdlr gdlr-core-left-align">
                            <div className="gdlr-core-divider-container" style={{ maxWidth: '54px' }}>
                              <div className="gdlr-core-divider-line gdlr-core-skin-divider"
                                  style={{ borderColor: '#3A4A26', borderWidth: '5px' }}>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="gdlr-core-pbf-element">
                          <div className="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align" style={{ paddingBottom: '22px' }}>
                            <div className="gdlr-core-text-box-item-content fontstyleset">
                              <p style={{fontWeight: "400"}}>Banana Bunks started as somewhat of a passion project during the tedious COVID-19 months. We decided to convert an old family home into a quirky, colorful hostel, now buzzing with life. In a sentimental fashion, we paid homage to our fathers' banana plantation in Polonnaruwa and the beautiful tropical island we live in by planting over 300 banana trees. Our father's plantation is an eco-friendly project, soaking up a few tons of wastewater each month which is discarded by our rice factory.</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Right Column */}
                  <div id="right-column" className="gdlr-core-pbf-column gdlr-core-column-30">
                    <div className="gdlr-core-pbf-column-content-margin">
                      <div className={`fade-in-right ${rightColVisible ? 'is-visible' : ''}`}>
                        <div className="gdlr-core-pbf-element">
                          <div className="gdlr-core-image-item gdlr-core-item-pdb gdlr-core-center-align gdlr-core-item-pdlr">
                            <div className="gdlr-core-image-item-wrap gdlr-core-media-image gdlr-core-image-item-style-rectangle" style={{ borderWidth: '0px' }}>
                              <img className="aboutside" src="/bbkandy/images/about/pic1.webp" alt="" width="570" height="750" title="about-2-right" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Second Section */}
            <div className="gdlr-core-pbf-wrapper bbkandybg no-sec-padding">
              <div className="gdlr-core-pbf-wrapper-content">
                <div className="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container">
                  <div id="stats-column" className="gdlr-core-pbf-column gdlr-core-column-30 gdlr-core-column-first">
                    <div className="gdlr-core-pbf-column-content-margin" style={{ padding: '30px 0px 40px 0px' }}>
                      <div className={`mright fade-in-left ${statsVisible ? 'is-visible' : ''}`} style={{paddingRight: "20px"}}>
                        <div className="gdlr-core-pbf-element">
                          <div className="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align" style={{ paddingBottom: '0px' }}>
                            <div className="gdlr-core-text-box-item-content green_back_second" style={{ textTransform: 'none' }}>
                              <p>
                                <span style={{ fontSize: '55px', fontWeight: '500', marginRight: '12px', letterSpacing: '4px' }}>14</span>
                                <span className="mmr30" style={{ fontSize: '22px', fontWeight: '400', marginRight: '80px', letterSpacing: '7px' }}>Bunks Beds</span>
                                <br />
                                <span style={{ fontSize: '55px', fontWeight: '500', marginRight: '12px', letterSpacing: '4px' }}>3</span>
                                <span style={{ fontSize: '22px', fontWeight: '400', marginRight: '12px', letterSpacing: '7px' }}>Private Rooms</span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="text-column" className="gdlr-core-pbf-column gdlr-core-column-30 green_back_about">
                    <div className="gdlr-core-pbf-column-content-margin">
                      <div className={`fade-in-right ${textVisible ? 'is-visible' : ''}`}>
                        <div className="gdlr-core-pbf-element">
                          <div className="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-left-align">
                            <div className="gdlr-core-text-box-item-content aboutfont"
                                style={{ lineHeight: '1.4', fontWeight: '400', letterSpacing: '5px', textTransform: 'none' }}>
                              <p >The creation of Banana Bunks was cultivated through the need for a cozy, enriching hostel in Kandy. Where travelers could retreat after a long day and still be in the company of other travel enthusiasts. Our goal is to provide a make-shift home to the many adventurous travelers that pass through this wonderful, ancient city!</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Video Section */}
            <div className="gdlr-core-pbf-wrapper videopadding">
              <div className="gdlr-core-pbf-background-wrap">
                <div className="gdlr-core-pbf-background gdlr-core-parallax">
                  <img className="vid_pic" src="/bbkandy/images/home/3.webp" alt="" />
                </div>
              </div>
            </div>

            {/* Facilities Section */}
            <div className="gdlr-core-pbf-element bbkandybg" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '50px 20px 18px 0' }}>
              <div
                className="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-center-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr"
                style={{ textAlign: 'center' }}>
                <div className="gdlr-core-title-item-title-wrap green_back_second">
                  <h3 className="gdlr-core-title-item-title gdlr-core-skin-title class-test hotale-additional-font"
                      style={{
                        fontSize: '80px',
                        fontWeight: '500',
                        letterSpacing: '0px',
                        textTransform: 'none',
                      }}>
                    Enjoy your every moment
                  </h3>
                  <div className="lower-text bodyfont">Explore our range of facilities</div>
                </div>
              </div>
            </div>

            <YogaAndPoolSection />
            <DiningAndLoungeSection />

            {/* Oryza Leisure Destinations */}
<div className="gdlr-core-pbf-wrapper-content" style={{ backgroundColor: '#eeb85e' }}>
  <div className="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container">
    <div className="gdlr-core-pbf-element" style={{ paddingTop: '40px' }}>
      <div className="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-center-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr"
          style={{ paddingBottom: '20px' }}>
        <div className="gdlr-core-title-item-title-wrap green_back_second">
          <h3 className="gdlr-core-title-item-title gdlr-core-skin-title class-test"
              style={{ fontSize: '65px', fontWeight: '400', letterSpacing: '0px', textTransform: 'none', color: '#3A4A26' }}>
            Explore Oryza Leisure destinations in Sri Lanka
          </h3>
        </div>
      </div>
    </div>

    {/* Petti Petti Mirissa */}
    <div className="gdlr-core-pbf-column gdlr-core-column-first"
        style={{ width: '100%', float: 'left', position: 'relative' }}>
      <div className="gdlr-core-pbf-column-content-margin"
          style={{ margin: '15px', padding: '285px 0px 30px 0px', borderRadius: '15px', position: 'relative' }}>
        <div className="gdlr-core-pbf-background-wrap oryza" style={{ 
          borderRadius: '15px',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 1,
          overflow: 'hidden'
        }}>
          <img className="desktopview" src="/bbkandy/images/about/petti.webp" alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          <img className="mobileview" src="/bbkandy/images/about/petti_mo.jpg" alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          <img className="smallphone" src="/bbkandy/images/about/petti_sm.jpg" alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        </div>
        <div className="gdlr-core-pbf-column-content clearfix" style={{ position: 'relative', zIndex: 2 }}>
          <div className="gdlr-core-pbf-element">
            <div className="gdlr-core-button-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-center-align"
                style={{ paddingBottom: '0px' }}>
              <a className="gdlr-core-button gdlr-core-button-solid gdlr-core-center-align gdlr-core-button-no-border"
                  href="/PettiPettiMirissa" style={{
                    fontSize: '15px',
                    fontStyle: 'normal',
                    fontWeight: '500',
                    letterSpacing: '0px',
                    color: '#3A4A26',
                    padding: '14px 36px',
                    textTransform: 'none',
                    borderRadius: '15px',
                    background: '#eeb85e'
                  }}>
                <span className="gdlr-core-content">Petti Petti Mirissa</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* Banana Bunks Mirissa */}
    <div className="gdlr-core-pbf-column gdlr-core-column-20 gdlr-core-column-first"
        style={{ position: 'relative' }}>
      <div className="gdlr-core-pbf-column-content-margin"
          style={{ margin: '15px', padding: '285px 0px 30px 0px', borderRadius: '15px', position: 'relative' }}>
        <div className="gdlr-core-pbf-background-wrap" style={{ 
          borderRadius: '15px',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 1,
          overflow: 'hidden'
        }}>
          <div className="gdlr-core-pbf-background gdlr-core-parallax">
            <img className="desktopview" src="/bbkandy/images/about/bbm.webp" alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            <img className="mobileview" src="/bbkandy/images/about/bbm_mo.jpg" alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            <img className="smallphone" src="/bbkandy/images/about/bbm_sm.jpg" alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          </div>
        </div>
        <div className="gdlr-core-pbf-column-content clearfix" style={{ position: 'relative', zIndex: 2 }}>
          <div className="gdlr-core-pbf-element">
            <div className="gdlr-core-button-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-center-align"
                style={{ paddingBottom: '0px' }}>
              <a className="gdlr-core-button gdlr-core-button-solid gdlr-core-center-align gdlr-core-button-no-border"
                  href="/BananaBunksMirissa"
                  style={{
                    fontSize: '15px',
                    fontStyle: 'normal',
                    fontWeight: '500',
                    letterSpacing: '0px',
                    color: '#3A4A26',
                    padding: '14px 36px',
                    textTransform: 'none',
                    borderRadius: '15px',
                    background: '#eeb85e'
                  }}>
                <span className="gdlr-core-content">Banana Bunks Mirissa</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* Kent Cottage */}
    <div className="gdlr-core-pbf-column gdlr-core-column-40"
        style={{ position: 'relative' }}>
      <div className="gdlr-core-pbf-column-content-margin"
          style={{ margin: '15px', padding: '285px 0px 30px 0px', borderRadius: '15px', position: 'relative' }}>
        <div className="gdlr-core-pbf-background-wrap" style={{ 
          borderRadius: '15px',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 1,
          overflow: 'hidden'
        }}>
          <div className="gdlr-core-pbf-background gdlr-core-parallax">
            <img className="desktopview" src="/bbkandy/images/about/kent.webp" alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            <img className="mobileview" src="/bbkandy/images/about/kent_mo.jpg" alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            <img className="smallphone" src="/bbkandy/images/about/kent_sm.jpg" alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          </div>
        </div>
        <div className="gdlr-core-pbf-column-content clearfix" style={{ position: 'relative', zIndex: 2 }}>
          <div className="gdlr-core-pbf-element">
            <div className="gdlr-core-button-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-center-align"
                style={{ paddingBottom: '0px' }}>
              <a className="gdlr-core-button gdlr-core-button-solid gdlr-core-center-align gdlr-core-button-no-border"
                  href="/Kent" style={{
                    fontSize: '15px',
                    fontStyle: 'normal',
                    fontWeight: '500',
                    letterSpacing: '0px',
                    color: '#3A4A26',
                    padding: '14px 36px',
                    textTransform: 'none',
                    borderRadius: '15px',
                    background: '#eeb85e'
                  }}>
                <span className="gdlr-core-content">Kent Cottage</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
            
          </div>
        </div>
      </div>
      <Footer />
      {/* Back to Top Button */}
      <div className="progress-wrap">
        <svg className="progress-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
          <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
        </svg>
      </div>
    </div>
  );
};

export default AboutUsPage;